// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import './fieldEditor';
import './stringFieldEditor';

/*
 * Editor of Field type Barcode
 * Renders an input field and if cordova barcodeScanner plugin is available,
 * Renders a button to execute the scan.
 * @constructor
 * @extends {StringFieldEditor}
 *
 * to enable the use of the scan button, execute the below code to mock the cordova 'cordova.plugins.barcodeScanner.scan()' method
 *
    window.cordova = {
        plugins: {
            barcodeScanner: {
                scan(success, failure) {
                    var r = Math.random();
                    if (r < 0.1) failure(new Error('Some error'))
                    else success({text: Math.round(r * 10000000000) + '', type: 'some type'});
                }
            }
        }
    };
 *
 */
myw.BarcodeFieldEditor = myw.StringFieldEditor.extend({
    tagName: 'div',

    className: 'bar-code',

    events: {
        'click .js-scanButton': 'onScan'
    },

    render() {
        if (!this.input) {
            const input = (this.input = $('<input>', { class: 'text', type: 'text' }));

            if (window.cordova && cordova.plugins && cordova.plugins.barcodeScanner) {
                const scan = $('<button>', {
                    class: 'js-scanButton field-edit-btn ui-button ui-corner-all ui-widget',
                    value: 'scan'
                }).html('Scan');
                scan.appendTo(this.$el);
                input.addClass('feature-edit-input-small').appendTo(this.$el);
            } else {
                input.appendTo(this.$el);
            }
        }
        this.input.val(this.fieldValue);
    },

    onScan() {
        const self = this;
        cordova.plugins.barcodeScanner.scan(
            result => {
                self.setValue(result.text);
            },
            error => {
                self.setValue();
                console.error(error);
            }
        );
    },

    /*
     * Returns the value currently set in the UI
     */
    getValue() {
        return this.$('input').val();
    }
});

export default myw.BarcodeFieldEditor;
